import React from 'react'
import PropTypes from 'prop-types'
import { Button, Row, Expander, ExpanderContent, TextField } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

export default function ConfirmChangePrompt({
  id,
  open,
  setOpen,
  changeMessage,
  onChange,
  onSave,
  onCancel,
  disabled,
}) {
  const { t } = useTranslation()

  return (
    <Expander open={open} setOpen={setOpen} data-testid="edit-access-control-expander">
      <ExpanderContent data-testid="edit-access-control-expander">
        <TextField
          id={id}
          label={t('reason', 'Reason')}
          value={changeMessage}
          onChange={onChange}
          fullwidth="true"
          multiline="true"
        />
        <Row>
          <Button emphasis="high" type="submit" onClick={onSave} disabled={disabled}>
            {t(`action.save`, 'Save')}
          </Button>
          <Button emphasis="medium" onClick={onCancel}>
            {t('action.cancel', 'Cancel')}
          </Button>
        </Row>
      </ExpanderContent>
    </Expander>
  )
}

ConfirmChangePrompt.propTypes = {
  id: PropTypes.string,
  open: PropTypes.bool,
  changeMessage: PropTypes.string,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  disabled: PropTypes.bool,
}
